import { Box } from '@mui/material';
import { useAppDispatch, useTypedSelector } from '../../../store/store';
import {
  TopTextContainer,
  ContentContainer,
  QuestionsContentContainer,
  Fadein,
  Title,
  AccountName,
} from './IncentiveBlock.styles';
// import { QuestionsComponent } from '../QuestionsComponent/QuestionsComponent';
import { PostUserQuestions } from '../../../store/slices/ui';
import { FC, useEffect, useState } from 'react';
// import { CampaignTypes } from '../../../api/models/rewards';
// import { useClientType } from '../../../services/hooks/useClientType';
import { UserInfoBlock } from '../Layout/UserInfoBlock/UserInfoBlock';
import { updateUserRequest } from '../../../store/slices/me';
import { useTrackEvent } from '../../hooks/useTrackEvent';
import { EventNames } from '../../constants/constants';
import { RatingSelector } from '../RatingSelector/RatingSelector';
import { PortalWrapper } from '../PortalWrapper/PortalWrapper';

enum IncentiveBlockStrings {
  WeAppreciateYou = 'We appreciate you!',
  seeyousoon = 'See You Soon!',
  holdTight = 'Hold Tight...',
  uploadAboutdone = 'Your upload is just about done!',
  LearnMore = 'Learn more ',
  DefaultIncentiveText = 'about the $1,000 Monthly Giveaway',
  FooterNote = 'Do you want to capture videos for your business? ',
  FooterAction = 'Learn More \u25B8',
  Question1 = 'Do you plan on visiting us again?',
  Question2 = 'Would you refer us to friends?',
  YourInToWin = 'You’re in to win!',
  Youhavebeenentered = 'You’ve been entered!',
  GoodLuck = 'Good luck, we’re cheering for\u00A0you!',
  SweepStakeText1 = 'You’ll also be entered in the',
  SweepStakeText2 = '$1,000 Monthly Giveaway!',
}

export const IncentiveBlock: FC<{ showQuestions?: boolean; showTopBanner?: boolean; isCompleteScreen?: boolean }> = ({
  showQuestions,
  // isCompleteScreen = false,
}) => {
  const { id } = useTypedSelector((state) => state.me);
  const { account } = useTypedSelector((state) => state.account);
  const { items, isLoading } = useTypedSelector((state) => state.ui.questions);
  const shouldHide = localStorage.getItem('hideInfoBlock');
  const { isUploadInprogress, uploadingProgress } = useTypedSelector((state) => state.upload);
  const { currentCampaign, primaryCampaign } = useTypedSelector((state) => state.rewards);
  const [isQS1Visible, setIsQS1Visible] = useState(!!shouldHide && !items.length && true);
  const [isQS1rendered, setIsQS1Rendered] = useState(!!shouldHide && !items.length && true);
  const [isQS2Visible, setIsQS2Visible] = useState(!!shouldHide && items.length && true);
  const [isQS2rendered, setIsQS2Rendered] = useState(!!shouldHide && items.length && true);
  const [showCenterText, setShowCenterText] = useState(false);
  const [showWaitText, setShowWaitText] = useState(false);

  const [isInfoBlockVisible, setIsInfoBlockVisible] = useState(!items.length && !shouldHide);
  const [isInfoBlockRendered, setIsInfoBlockRendered] = useState(!items.length && !shouldHide);
  const { trackEvent } = useTrackEvent();
  const hasAnsweredQuestions = items.length > 1;
  const showGoodByeText = !isUploadInprogress && uploadingProgress === 100 && hasAnsweredQuestions;
  const showHoldTightText = isUploadInprogress && hasAnsweredQuestions;
  const emailRequired = currentCampaign ? !!currentCampaign?.emailRequired : !!primaryCampaign?.emailRequired;

  const updateEmail = async (email: string) => {
    await dispatch(
      updateUserRequest({
        email: email,
        userId: id,
      }),
    );
  };

  useEffect(() => {
    let timeout: number;
    if (showHoldTightText) {
      timeout = setTimeout(() => {
        setShowWaitText(true);
      }, 1000);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [showHoldTightText]);

  useEffect(() => {
    let timeout: number;
    if (showGoodByeText) {
      setShowWaitText(false);
      timeout = setTimeout(() => {
        setShowCenterText(true);
      }, 2000);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [showGoodByeText]);

  //   const questions = [IncentiveBlockStrings.Question1, IncentiveBlockStrings.Question2];
  // const { isUVMClient } = useClientType();

  const dispatch = useAppDispatch();
  const hasUserCompletedQuestions = !!(items.length > 1) && !isLoading;
  const handleAnswerClick = (answer: string, question: string) => {
    dispatch(
      PostUserQuestions({
        id,
        answer,
        question,
      }),
    );
  };
  const handleInfoBlockTransitionEnd = () => {
    if (!isInfoBlockVisible) {
      setIsInfoBlockRendered(false); // Remove the component after transition
    }
    setIsQS1Visible(true);
    setIsQS1Rendered(true);
  };
  // const dimissedPropertyNames = ['box-shadow', 'background-color'];
  const handleTransitionEnd = (e: any) => {
    if (e.target !== e.currentTarget) return;
    if (e.propertyName !== 'opacity') return;
    // console.log('event.propertyName', event.propertyName);
    // if ( dimissedPropertyNames.includes(event.propertyName) ) {
    //   return;
    // }
    if (!isQS1Visible) {
      setIsQS1Rendered(false); // Remove the component after transition
    }
    setIsQS2Visible(true);
    setIsQS2Rendered(true);
  };
  const handleTransitionEnd2 = (e: any) => {
    if (e.target !== e.currentTarget) return;
    if (e.propertyName !== 'opacity') return;
    // console.log('event.propertyName', event.propertyName);
    // if (dimissedPropertyNames.includes(event.propertyName) ) {
    //   return;
    // }
    if (!isQS2Visible) {
      setIsQS2Rendered(false); // Remove the component after transition
    }
  };

  return (
    <>
      {showCenterText && (
        <PortalWrapper percent={65}>
          <Fadein as={TopTextContainer}>
            <Title>{IncentiveBlockStrings.seeyousoon}</Title>
            <AccountName>{account.name}</AccountName>
          </Fadein>
        </PortalWrapper>
      )}
      
      {showWaitText && (
        <PortalWrapper percent={65}>
          <Fadein as={TopTextContainer}>
            <Title>{IncentiveBlockStrings.holdTight}</Title>
            <AccountName>{IncentiveBlockStrings.uploadAboutdone}</AccountName>
          </Fadein>
        </PortalWrapper>
      )}
      {!isLoading && showQuestions && !hasUserCompletedQuestions && isInfoBlockRendered ? (
        <PortalWrapper>
          <ContentContainer
            sx={{ opacity: isInfoBlockVisible ? 1 : 0, transition: 'opacity 0.5s ease-in-out' }}
            onTransitionEnd={handleInfoBlockTransitionEnd}
          >
            <UserInfoBlock
              onClick={(email?: string) => {
                localStorage.setItem('hideInfoBlock', 'true');
                setIsInfoBlockVisible(false);
                setIsQS1Visible(true);
                setIsQS1Rendered(true);
                if (emailRequired && email) {
                  updateEmail(email);
                }
              }}
            />
          </ContentContainer>
        </PortalWrapper>
      ) : (
        <></>
      )}

      {!isLoading && showQuestions && !hasUserCompletedQuestions && isQS1rendered ? (
        <PortalWrapper>
          <QuestionsContentContainer
            sx={{ opacity: isQS1Visible ? 1 : 0, transition: 'opacity 0.5s ease-in-out' }}
            onTransitionEnd={handleTransitionEnd}
          >
            <RatingSelector
              question={IncentiveBlockStrings.Question1}
              onClick={(answer: string) => {
                handleAnswerClick(answer, IncentiveBlockStrings.Question1);
                setIsQS1Visible(false);
                trackEvent({ action: EventNames.question_1 });
              }}
            />
          </QuestionsContentContainer>
        </PortalWrapper>
      ) : (
        <></>
      )}
      {!isLoading && showQuestions && !hasUserCompletedQuestions && isQS2rendered ? (
        <PortalWrapper>
          <QuestionsContentContainer
            sx={{ opacity: isQS2Visible ? 1 : 0, transition: 'opacity 0.5s ease-in-out' }}
            onTransitionEnd={handleTransitionEnd2}
          >
            <RatingSelector
              question={IncentiveBlockStrings.Question2}
              onClick={(answer: string) => {
                handleAnswerClick(answer, IncentiveBlockStrings.Question2);
                setIsQS2Visible(false);
                trackEvent({ action: EventNames.question_2 });
              }}
            />
          </QuestionsContentContainer>
        </PortalWrapper>
      ) : (
        <></>
      )}

      <ContentContainer>
        {/* All content commented out - keeping structure */}
      </ContentContainer>
      <Box
        position={'absolute'}
        bottom={'15%'}
        left="0"
        display="flex"
        alignItems={'center'}
        justifyContent={'center'}
        width="100%"
      >
        {/* {isCustomRewardCampaign && !isUVMClient && (
          <Box display="flex" flexDirection={'column'} alignItems={'center'} justifyContent={'center'} width="100vw">
            <Typography className={classes.getStartedText}>{IncentiveBlockStrings.SweepStakeText1}</Typography>
            <Typography className={classes.sweepStakeTitle}>{IncentiveBlockStrings.SweepStakeText2}</Typography>
            <a
              href="http://www.socialvenu.com/give"
              target="_blank"
              style={{ color: '#2D11AD', fontWeight: 'bold', pointerEvents: isCompleteScreen ? 'auto' : 'none' }}
            >
              {IncentiveBlockStrings.LearnMore}
            </a>
          </Box>
        )} */}
        {/* <Typography className={classes.bottomText}>
          {IncentiveBlockStrings.FooterNote}
          <a href="https://www.socialv.io" target="_blank" style={{ color: '#2D11AD', fontWeight: 'bold' }}>
            {IncentiveBlockStrings.FooterAction}
          </a>
        </Typography> */}
      </Box>
    </>
  );
};
